function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2593",
  "data-name": "Group 2593",
  transform: "translate(-64.006 -617.893)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2591",
  "data-name": "Group 2591",
  transform: "translate(0 -141)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-02-beauty-appearance",
  transform: "translate(23.577 742.349)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2568",
  "data-name": "Group 2568",
  transform: "translate(41.929 18.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2566",
  "data-name": "Group 2566",
  transform: "translate(13.109 24.446)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2565",
  "data-name": "Group 2565",
  transform: "translate(0 7.364)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  "data-name": "Path 3640",
  d: "M92.678,99.586s-.823,11.957.374,15.531a16.876,16.876,0,0,0,3.359,5.983",
  transform: "translate(-63.324 -87.121)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3641",
  "data-name": "Path 3641",
  d: "M61.53,115.205c2.223-4.027,0-16.429,0-16.429",
  transform: "translate(-58.256 -86.988)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3642",
  "data-name": "Path 3642",
  d: "M57.613,88.718c.627,3.135,2.077,5.378,3.274,7.742C64.425,103.393,69.071,106.9,74.1,106.9c4.882,0,9.383-3.162,12.863-9.767a123.174,123.174,0,0,0,5.586-12.465",
  transform: "translate(-57.613 -84.673)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_158",
  "data-name": "Ellipse 158",
  cx: 1.714,
  cy: 1.714,
  r: 1.714,
  transform: "translate(21.76 0.634)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_159",
  "data-name": "Ellipse 159",
  cx: 1.713,
  cy: 1.713,
  r: 1.713,
  transform: "translate(7.818 0.635)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3643",
  "data-name": "Path 3643",
  d: "M61.78,77.779c.7-.957,2.331-1.916,5.206-1.916s4.241.807,5.206,1.916",
  transform: "translate(-58.297 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3644",
  "data-name": "Path 3644",
  d: "M80.478,77.779c.7-.957,2.329-1.916,5.206-1.916s4.236.807,5.206,1.916",
  transform: "translate(-61.367 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3645",
  "data-name": "Path 3645",
  d: "M76.907,99.718c-2.281,0-3.9-2.075-4.358-2.594a18.157,18.157,0,0,1,2.787-.911c.486,0,.831.468,1.546.468.42,0,.808-.424,1.258-.419a23.871,23.871,0,0,1,3.026.863C80.711,97.642,79.3,99.718,76.907,99.718Z",
  transform: "translate(-60.065 -79.204)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3649",
  "data-name": "Path 3649",
  d: "M49.278,46.686s-7.349,9.63-7.349,25.379c0,13.288,10.457,26.24,10.457,26.24s.842-18.25,7.394-29.482A46.036,46.036,0,0,1,83.164,49.377a23.969,23.969,0,0,1,7.794,11.344c2.171,6.952-1.381,18.447-1.48,18.842s6.671-7.434,8.385-14.4c1.642-6.679,1.676-10.95-3.156-18.545",
  transform: "translate(-41.929 -46.615)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}))), /*#__PURE__*/React.createElement("line", {
  id: "Line_575",
  "data-name": "Line 575",
  x2: 36,
  transform: "translate(109.5 802.5)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_576",
  "data-name": "Line 576",
  x2: 37,
  transform: "translate(108.5 807.5)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_178",
  "data-name": "Ellipse 178",
  transform: "translate(111 811)",
  fill: "#fff",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_179",
  "data-name": "Ellipse 179",
  transform: "translate(119 819)",
  fill: "#fff",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_180",
  "data-name": "Ellipse 180",
  transform: "translate(127 811)",
  fill: "#fff",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_181",
  "data-name": "Ellipse 181",
  transform: "translate(136 819)",
  fill: "#fff",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 1.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Path_3739",
  "data-name": "Path 3739",
  transform: "translate(122 648)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5 8.5 C 3.070090055465698 8.5 1.5 6.929910182952881 1.5 5.000000476837158 C 1.5 4.010550498962402 2.104540109634399 1.906680345535278 2.97012996673584 -0.1162296682596207 C 3.80794620513916 -2.074209928512573 4.563724994659424 -3.218803405761719 5 -3.719589471817017 C 5.436275005340576 -3.218803405761719 6.19205379486084 -2.074209928512573 7.02987003326416 -0.1162296682596207 C 7.89546012878418 1.906680345535278 8.5 4.010550498962402 8.5 5.000000476837158 C 8.5 6.929910182952881 6.929910182952881 8.5 5 8.5 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 5 -0.9194145202636719 C 4.750102996826172 -0.4315805435180664 4.479061603546143 0.1499390602111816 4.201389789581299 0.8265204429626465 C 3.326169967651367 2.95913028717041 3 4.5182204246521 3 5.000000476837158 C 3 6.102800369262695 3.897200107574463 7 5 7 C 6.102799892425537 7 7 6.102800369262695 7 5.000000476837158 C 7 4.5182204246521 6.673830032348633 2.95913028717041 5.798610210418701 0.8265204429626465 C 5.520938396453857 0.1499390602111816 5.249897003173828 -0.4315805435180664 5 -0.9194145202636719 M 5 -5.4398193359375 C 6.778530120849609 -5.4398193359375 10 2.238580226898193 10 5.000000476837158 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5.000000476837158 C 0 2.238580226898193 3.221469879150391 -5.4398193359375 5 -5.4398193359375 Z",
  stroke: "none",
  fill: "#a64daa"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_3740",
  "data-name": "Path 3740",
  transform: "translate(132 644.241)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 3.302734375 3.258903026580811 C 2.308704376220703 3.258903026580811 1.500004410743713 2.450202941894531 1.500004410743713 1.456173062324524 C 1.500004410743713 0.9821030497550964 1.799224376678467 -0.2142669558525085 2.37110447883606 -1.583616971969604 C 2.716740369796753 -2.411226749420166 3.044445037841797 -3.022661209106445 3.302734375 -3.434531927108765 C 3.561023712158203 -3.022661209106445 3.888728380203247 -2.411226749420166 4.23436450958252 -1.583616971969604 C 4.806244373321533 -0.2142669558525085 5.105464458465576 0.9821030497550964 5.105464458465576 1.456173062324524 C 5.105464458465576 2.450202941894531 4.296764373779297 3.258903026580811 3.302734375 3.258903026580811 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 3.302734375 0.2166861295700073 C 3.095891714096069 0.8619664907455444 3.009307146072388 1.305235981941223 3.000126600265503 1.464828252792358 C 3.004722118377686 1.627773284912109 3.138697862625122 1.758902549743652 3.302734375 1.758902549743652 C 3.466770887374878 1.758902549743652 3.600746631622314 1.627773284912109 3.605342149734497 1.464828252792358 C 3.596161603927612 1.305235981941223 3.509577035903931 0.8619664907455444 3.302734375 0.2166861295700073 M 3.302734375 -5.439817428588867 C 4.477534294128418 -5.439817428588867 6.605464458465576 -0.3678774535655975 6.605464458465576 1.456172466278076 C 6.605464458465576 3.280222654342651 5.126784324645996 4.758902549743652 3.302734375 4.758902549743652 C 1.478684425354004 4.758902549743652 4.291534423828125e-06 3.280222654342651 4.291534423828125e-06 1.456172466278076 C 4.291534423828125e-06 -0.3678774535655975 2.127934455871582 -5.439817428588867 3.302734375 -5.439817428588867 Z",
  stroke: "none",
  fill: "#a64daa"
})));

var SvgOilinessIcon = function SvgOilinessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82.994,
    height: 69.979,
    viewBox: "0 0 82.994 69.979",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOilinessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oiliness-icon.c5c73323.svg";
export { ForwardRef as ReactComponent };